import * as d3 from 'd3'
export default {
  methods: {

    draw_Header() {
      
      let head = this.canvasForm
      .append('g')
      .attr('transform', `translate(${this.table.x}, ${this.table.y})`)

      this.columns.forEach((d,i)=> {
        
        if(d.group) {
          let x = d.sx + (this.columns[i+d.span-1].ex - d.sx)/2
          head
          .append('text')
          .attr('x', x).attr('y', 21)
          .attr('font-size', 11).attr('fill', '#333')
          .attr('text-anchor', 'middle')
          .text(d.group)
        }
        if(i>2) {
          head
          .append('text')
          .attr('x', d.mx).attr('y', 41)
          .attr('font-size', 9).attr('fill', '#333')
          .attr('text-anchor', 'middle')
          .text(d.name)
        } else {
          head
          .append('text')
          .attr('x', d.mx).attr('y', 30)
          .attr('font-size', 11).attr('fill', d.code == 'SUBSYS' ? '#44A9DF' : '#333')
          .attr('text-anchor', 'middle')
          .text(d.name)
        }
        if(d.vLine == 1) this.gmx_Line(head, d.ex, d.ex, 5, this.table.height,  '#E0E0DF', .75, 1)
      })

      this.gmx_Line(head, this.columns[2].ex, this.table.width, 28,  28,  '#E0E0DF', 1, 1)
      this.gmx_Line(head, 0, this.table.width, 6,  6,  '#757575', .5, 1)
      this.gmx_Line(head, 0, this.table.width, this.table.headHeight, this.table.headHeight, '#757575', .5, 1)
      this.gmx_Line(head, 0, this.table.width, this.table.height, this.table.height, '#757575', .5, 1)
    },

  }
}